module.exports = __webpack_public_path__ + "img/arrow-right-dark-background.70b01413.svg";